export default __webpack_public_path__ + "bd5250bf8d5a9b9bfe1a0c75cf34247b.webp";